import { CollectionSurveyQuestions } from '@src/generated/hooks';
import { getErrorMessage } from '../utils/validation';

/**
 * @name validateMultiChoice
 * @description tbd...
 */
export const validateMultiChoice = (
  question: CollectionSurveyQuestions,
  answer?: string[]
): string => {
  const { choices = [], choices_min, choices_max, required, type } = question;

  if (type !== 'multi_choice') throw new Error('Invalid question type');

  // Not required and no value to validate
  if (!required && !answer) return '';

  // Easy to validate
  if (!answer) return getErrorMessage(question);
  if (!Array.isArray(answer)) return getErrorMessage(question);

  // Filter out any invalid options
  const options = choices.map((choice) => choice.key);
  const answers = answer.filter((answer) => options.includes(answer));

  // Check min/max
  const isMaxValid = choices_max ? answers.length <= choices_max : true;
  const isMinValid = choices_min ? answers.length >= choices_min : true;
  const isValid = isMaxValid && isMinValid;

  return isValid ? '' : getErrorMessage(question);
};
